// extracted by mini-css-extract-plugin
module.exports = {"root":"companionsSummary_root___qpx6","item":"companionsSummary_item__OyP1e"};